import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';
export default function useQueryParams() {
  var location = useLocation();
  return useMemo(function () {
    return parse(location.search);
  }, [location.search]);
}